"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.auth = exports.phoneIdentifier = exports.hash = exports.account = exports.email = exports.subject = exports.token = exports.user = exports.RefreshToken = exports.Password = exports.IdentityToken = exports.userAccount = exports.Authentication = exports._self = exports.ns = exports.loadData = void 0;
const JSONLD_1 = require("lincd-jsonld/lib/utils/JSONLD");
const NameSpace_1 = require("lincd/lib/utils/NameSpace");
const package_1 = require("../package");
//import all the exports of this file as one variable called _this (we need this at the end)
const _this = __importStar(require("./auth"));
/**
 * Load the data of this ontology into memory, thus adding the properties of the entities of this ontology to the local graph.
 */
var loadData = () => {
    return Promise.resolve().then(() => __importStar(require('../data/auth.json'))).then((data) => JSONLD_1.JSONLD.parse(data));
};
exports.loadData = loadData;
/**
 * The namespace of this ontology, which can be used to create NamedNodes with URI's not listed in this file
 */
exports.ns = (0, NameSpace_1.createNameSpace)('http://lincd.org/ont/auth/');
/**
 * The NamedNode of the ontology itself
 */
exports._self = (0, exports.ns)('');
//A list of all the entities (Classes & Properties) of this ontology, each exported as a NamedNode
exports.Authentication = (0, exports.ns)('Authentication');
exports.userAccount = (0, exports.ns)('userAccount');
exports.IdentityToken = (0, exports.ns)('IdentityToken');
exports.Password = (0, exports.ns)('Password');
exports.RefreshToken = (0, exports.ns)('RefreshToken');
exports.user = (0, exports.ns)('user');
exports.token = (0, exports.ns)('token');
exports.subject = (0, exports.ns)('subject');
exports.email = (0, exports.ns)('email');
exports.account = (0, exports.ns)('account');
exports.hash = (0, exports.ns)('hash');
exports.phoneIdentifier = (0, exports.ns)('phoneIdentifier');
//An extra grouping object so all the entities can be accessed from the prefix/name
exports.auth = {
    Authentication: exports.Authentication,
    userAccount: exports.userAccount,
    IdentityToken: exports.IdentityToken,
    Password: exports.Password,
    RefreshToken: exports.RefreshToken,
    user: exports.user,
    token: exports.token,
    email: exports.email,
    phoneIdentifier: exports.phoneIdentifier,
    subject: exports.subject,
    account: exports.account,
    hash: exports.hash,
};
//Registers this ontology to LINCD.JS, so that data loading can be automated amongst other things
(0, package_1.linkedOntology)(_this, exports.ns, 'auth', exports.loadData, '../data/auth.json');
//# sourceMappingURL=auth.js.map